import UButton from "../../../Button/UButton/UButton";
import RequestServices from "../../../../../frontend.services/RequestServices/RequestServices";
import { isTerminal } from "../../../../../constants";
import { ScrollButton } from "../../../componentsTerminal/ScrollButton/ScrollButton";
import { unsetCurrentDocumentAction } from "../../../../../redux/actions/Requests/CurrentRequest/setCurrentDocument.action";
import {
    approveLocalTripThunk,
    cancelLocalTripThunk,
} from "../../../../../redux/actions/LocalTrips/thunk/LocalTrips.thunk.action";
import {
    getLeaderRequestsThunkAction,
} from "../../../../../redux/actions/Requests/LeaderRequests/thunk/getLeaderRequests.thunk.action";


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";

isTerminal ? import("./LocalTripDetailModalTerminal.scss") : import("./LocalTripDetailModal.scss");

const LocalTripDetailModal = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const currentRequest = useSelector((state) => state.requests.singleDocument);
    const [loader, setLoader] = useState(false);
    const [reject, setReject] = useState(false);
    const [input, setInput] = useState("");

    const handleRequestAction = (action, reason = null) => {
        const { id, orderNumber } = currentRequest.currentRequest;
        console.log(id);
        switch (action) {

        case "approve":
            const data = {
                    "decision": "APPROVED",
                }
            dispatch(
                approveLocalTripThunk(
                    id,
                    data,
                    {
                        setState: setLoader,
                        setDescription: props.setDescription,
                    }
                )
            );
            break;
        case "reject":
            const temp = {
                "decision": "REJECTED",
                "comment": input,
            }
            dispatch(
                approveLocalTripThunk(
                    id,
                    temp,
                    {
                        setState: setLoader,
                        setDescription: props.setDescription,
                    }
                )
            );
            break;
        default:
            break;
        }
    };


    const skipRejectHandler = () => {
        setReject(false);
        props.close();
    };

    useEffect(() => {
        return () => {
            dispatch(unsetCurrentDocumentAction());
            dispatch(getLeaderRequestsThunkAction());
        };
    }, []);

    if (!currentRequest) {
        return (
            <div className="request-modal-loader">
                <ClipLoader color="#6DCDF6" />
            </div>
        );
    }


    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "48px" }}>
            {isTerminal && <ScrollButton propsClassName={".request-modal__table"} />}

            {loader ? (
                <div style={{ margin: "auto", textAlign: "center", width: "400px" }}>
                    <ClipLoader color="#6DCDF6" />
                </div>
            ) : (
                <>
                    <div className="request-modal__table">
                        {reject ? (
                            <div className="request-modal__table__line reject">
                                <div className="left-column">укажите причину отклонения:</div>
                                <div className="right-column">
                                    <input
                                        autoFocus
                                        placeholder="Введите текст"
                                        name="reason"
                                        className="right-column__input"
                                        maxLength={255}
                                        onChange={(e) => setInput(e.target.value)}
                                    />
                                </div>
                            </div>
                        ) : (
                            <>
                                {currentRequest &&
                                    Object.keys(currentRequest.currentRequestCard).map((el, index) => (
                                        <div key={index} className="request-modal__table__line">
                                            <div className="left-column">{el}</div>
                                            <div className="right-column">
                                                {currentRequest.currentRequestCard[el]}
                                            </div>
                                        </div>
                                    ))
                                }

                                {currentRequest.currentRequest?.approver && (
                                    <div className="request-modal__table__line">
                                        <div className="left-column">
                                            ФИО согласующего

                                        </div>
                                        <div className="right-column">
                                            <div className="approvers">
                                                <span
                                                    className={
                                                      "approvers__active"

                                                    }
                                                >
                                                    {currentRequest.currentRequest.approver.fullName}
                                                </span>


                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>

                    <div className="buttons-wrapper">
                        {!props.isLeader ? (
                            <>
                            </>
                        ) : (
                            <>
                                <UButton
                                    className="request-modal__button"
                                    onClick={reject ? skipRejectHandler : () => setReject(true)}
                                    disabled={reject ? false : currentRequest.currentRequest.status.value !== "PENDING_APPROVAL"}
                                >
                                    {reject ? "отмена" : "отклонить"}
                                </UButton>
                                <UButton
                                    className="request-modal__button"
                                    disabled={
                                        reject ? !input : currentRequest.currentRequest.status.value !== "PENDING_APPROVAL"
                                    }
                                    onClick={
                                        reject
                                            ? () => handleRequestAction("reject", input,)
                                            : () => handleRequestAction("approve", currentRequest.currentRequest.id)
                                    }
                                >
                                    {reject ? "подтвердить" : "согласовать"}
                                </UButton>
                            </>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default LocalTripDetailModal;
